import React, {useLayoutEffect, useRef, useState} from 'react';
import AppText from '../../../common/AppText';
import { useMemo } from 'react';
import {boxSettingsProps, USER_FIELDS, USER_SITE_FIELDS} from '../../../../services/ConstHelper';
import { t } from '../../../../services/i18n';
import CustomTaskDoneCheckbox from '../../../common/CustomTaskDoneCheckbox';
import { Colors } from '../../../../styles/Colors';
import { useSelector } from 'react-redux';
import InfoTooltip from "../../../common/InfoTooltip";
import {HStack} from "native-base";
import usePermissions from "../../../../services/Permissions";

const RequiredFieldsSettings = ({initialValues, values, setFieldValue, infoTooltip, ...rest}) => {
    const {has} = usePermissions()
    let {fields, flows} = useMemo(() => boxSettingsProps[initialValues?.prop_name] || {}, [initialValues]);
    flows = flows.filter(flow => !has('allowRegisterGroupMember') ? flow !== 'child' : true)
    const box = useSelector(state => state.box.box);
    const isGlobal = box?.locations_box[0]?.country_code !== 'IL';

    const flowsCount = flows?.length || 0;
    const [firstColPx, setFirstColPx] = useState(0);
    const labelRefs = useRef([]);

    useLayoutEffect(() => {
        const maxWidth = Math.max(...labelRefs.current.map(el => el?.offsetWidth || 0));
        if (maxWidth && Math.abs(firstColPx - maxWidth) > 1) setFirstColPx(Math.ceil(maxWidth) + 8);
    }, [fields, flows]);

    const gridColumns = `${firstColPx ? firstColPx + 'px' : 'max-content'} repeat(${flowsCount}, 1fr)`;
    const gridGap = '1rem';

    const isDisabled = (field, flow) => {
        switch (initialValues?.prop_name) {
            case USER_FIELDS:
                const globalDisabled = isGlobal ? ['city.member', 'address.member'] : [];
                return [...globalDisabled, 'first_name.member', 'first_name.lead', 'last_name.member', 'source_fk.member', 'users_boxes_owner_id.member', 'personal_id.lead'].includes(`${field}.${flow}`);
            case USER_SITE_FIELDS:
                return ['first_name.member', 'first_name.lead', 'first_name.child', 'last_name.member', 'last_name.lead', 'last_name.child', 'email.child', 'phone.member'].includes(`${field}.${flow}`);
            default:
                return false;
        }
    }

    const isDefaultChecked = (field, flow) => {
        if(field === 'last_name' && flow === 'child') {
            return true
        }
        return values.properties?.[field]?.[`${flow}Required`]
    }

    return <div>
        <div style={{paddingBlock: '0.5rem', borderBottom: '1px solid #e0e0e0', display: 'grid', gridTemplateColumns: gridColumns, columnGap: gridGap, alignItems: 'center'}}>
            <div ref={el => (labelRefs.current[0] = el)}>
                <AppText boldFont>{t('field-name')}</AppText>
            </div>
            {flows?.map(flow => (
                <div style={{textAlign: 'center'}} key={flow}>
                    <HStack justifyContent={'center'}>
                        <AppText boldFont>{t(`${flow}-flow`)}</AppText>
                        {infoTooltip && infoTooltip[flow] && <InfoTooltip title={infoTooltip[flow]}/>}
                    </HStack>
                </div>
            ))}
        </div>
        {fields?.map(field => (
            <div style={{paddingBlock: '1rem', borderBottom: '1px solid #e0e0e0', display: 'grid', gridTemplateColumns: gridColumns, columnGap: gridGap, alignItems: 'center'}} key={field}>
                <div ref={el => (labelRefs.current[(labelRefs.current?.length || 0)] = el)}>
                    <AppText>{t(`${field.replaceAll('_', '-')}`)}</AppText>
                </div>
                {flows?.map(flow => (
                    <div style={{display: 'flex', justifyContent: 'center'}} key={flow}>
                        <CustomTaskDoneCheckbox
                            onClick={() => {}}
                            checkedTooltip={isDisabled(field, flow) ? t(`disabled-${flow}-${field.replaceAll('_', '-')}-tooltip`) : ''}
                            uncheckedTooltip={isDisabled(field, flow) ? t(`disabled-${flow}-${field.replaceAll('_', '-')}-tooltip`) : ''}
                            colors={{primary: Colors.newDesign.mainBlue, primaryBorder: '#E0E0E0', primaryHover: Colors.newDesign.mainBlueHover}}
                            disabled={isDisabled(field, flow)}
                            checked={values.properties?.[field] === undefined ? true : isDefaultChecked(field, flow)}
                            onChange={(e) => {
                                setFieldValue(`properties.${field}.${flow}Required`, e.target.checked)
                            }}
                        />
                    </div>
                ))}
            </div>
        ))}

    </div>
}

export default RequiredFieldsSettings;